module.exports = __webpack_public_path__ + "/images/constructor-hiw.generic.03292a6.png";